import { setCompanyDetailsData, resetCompanyDetailsData } from '../../../redux/companyDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import CompanyDetailsContent from './companyDetailsContent';
import CompanyDetailsHeader from './companyDetailsHeader';
import { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const CompanyDetails = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const fetchCompanyDetails = useCallback(async () => {
    try {
      const { data, status } = await axios.get(`company/${id}`);
      if ((status === 200 || status === 201) && data) {
        dispatch(setCompanyDetailsData(data));
        setLoading(false);
      } else {
        setLoading(false);
        console.warn('Unexpected response status or empty data:', status, data);
      }
    } catch (error) {
      setLoading(false);
      console.error('Erreur lors de la récupération des informations de l’entreprise :', error);
      CustomErrorLogger(error, 'Erreur dans fetchCompanyDetails');
    }
  }, [id, dispatch]);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fetch company details on mount and cleanup on unmount
  useEffect(() => {
    fetchCompanyDetails();
    return () => {
      dispatch(resetCompanyDetailsData());
    };
  }, [fetchCompanyDetails, dispatch]);

  return (
    <Box>
      {loading ?
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <CircularProgress
            sx={{
              '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
            }}
          />
        </Box>
        :
        <Box>
          <CompanyDetailsHeader />
          <SuccessfullModifyDialog />
          <CompanyDetailsContent />
        </Box>
      }
    </Box>
  );
}

export default CompanyDetails;